var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom"},[_vm._v(" 泉州市文明办、泉州市志工办、共青团泉州市委、泉州市民政局主办，泉州市志愿者协会承办 "),_c('br'),_vm._v(" Copyright © 2012-2020 nbzyz.org All Rights Reserved 闵ICP备09012916号-20 ")])
}]

export { render, staticRenderFns }